import roles from '@/utils/roles'
import { tabsToRoutes } from '@/components/shared/tabs/utils'
import tabs from './tabs'

export default {
    path: '/manage/executives/:executiveId',
    display: 'Manage Executive',
    name: 'manage-executive',
    props: route => ({
        executiveId: parseInt(route.params.executiveId),
    }),
    component: () => import(/* webpackChunkName: "manageexecutive" */ './manage-executive-page'),
    meta: {
        layout: 'app',
        roles: [
            roles.admin,
            roles.dataEntry,
            roles.dataEntryJobHistory,
            roles.dataEntryInterviewSurveys,
            roles.matching,
            roles.inHouseDataEntry,
            roles.research,
        ],
    },
    children: tabsToRoutes(tabs),
}
